import React,{useState,useEffect} from 'react'

function LogoCard({logoUrl}) {
    const [logo,setLogo] = useState(logoUrl)
    useEffect(()=>{
        console.log(logoUrl)
        setLogo(logoUrl)    
    },[logoUrl])

  return (
    <div className="info-box card mt-1">
        <i className='bi bi-card-image'></i>
        <h3>Logo</h3>
        <hr/>
        <div>
            <img src={logoUrl} className='img-fluid'/>
        </div>
    </div>
   
  )
}

export default LogoCard